// import parseTime, formatTime and set to filter
export { parseTime, formatTime } from "@/utils";
export { datetimeFromTimestamp, timeFromTimestamp, dateFromTimestamp } from "@/utils/date";
import moment from "@/utils/moment";

/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }
  return time + label + "s";
}

/**
 * @param {number} time
 */
export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time);
  if (between < 3600) {
    return pluralize(~~(between / 60), " minute");
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), " hour");
  } else {
    return pluralize(~~(between / 86400), " day");
  }
}

/**
 * Number formatting
 * like 10000 => 10k
 * @param {number} num
 * @param {number} digits
 */
export function numberFormatter(num, digits) {
  const si = [
    { value: 1e18, symbol: "E" },
    { value: 1e15, symbol: "P" },
    { value: 1e12, symbol: "T" },
    { value: 1e9, symbol: "G" },
    { value: 1e6, symbol: "M" },
    { value: 1e3, symbol: "k" },
  ];
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (
        (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, "$1") +
        si[i].symbol
      );
    }
  }
  return num.toString();
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ","));
}

/**
 * Upper case first char
 * @param {String} string
 */
export function uppercaseFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * Show number as currency
 * @param value the money amount
 * @returns
 */
export function toCurrency(value) {
  const formatter = new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
  });
  return formatter.format(parseFloat(value));
}

/**
 * Show number as currency
 * @param value the money amount
 * @returns
 */
export function centsToCurrency(value) {
  return toCurrency(value / 100);
}

export function timestamp(date) {
  return date ? moment()(date * 1000).format("DD/MM/YY HH:mm") : "";
}

export function formatState(state) {
  switch (state) {
    case 8:
      return "Devuelto";
    case 9:
      return "Ausencia";
    case 10:
      return "Cancelado";
    case 11:
      return "Cancelado Tiempo";
    default:
      break;
  }
}
